﻿define([
        'underscore',
        'dhtmlxMessage',
    ],
    function (_) {
        var Undo = {};

        var actionToString = function (e) {
            var header = e.Tm + ' ' + e.DomainUsername + ' ' + e.ActionName;
            var content = '';
            if (e.ActionName == "SetAttributeValue") {
                content = e.Payload.attributeName + ' from "' + e.Payload.oldValue + '" to "' + e.Payload.newValue + '"';
            }
            return header + content;
        };

        var undoSetAttributeValue = function (payload) {
            $.ajax({
                url: '/' + payload.controller + '/' + payload.id + "/" + payload.attributeName,
                type: 'PUT',
                contentType: 'application/json',
                data: JSON.stringify(payload.oldValue),
                dataType: 'json'

            }).done(function (data) {
                if (data.outcome == "OK") {
                    location.reload();
                } else {
                    $.Notify.show('Error while undoing SetAttributeValue for ' + payload.attributeName + ', outcome=' + data.outcome);
                }
            }).fail(function (data) {
                $.Notify.show('Error while undoing SetAttributeValue for ' + payload.attributeName + ', status=' + data.status);
            });
        };

        var undo = function (action) {
            if (action.ActionName == "SetAttributeValue") {
                dhtmlx.confirm({
                    type: "confirm",
                    text: "You are about to undo '" + actionToString(action) + "'<br/>Continue?",
                    callback: function (result) {
                        if (result) {
                            undoSetAttributeValue(action.Payload);
                        }
                    }
                });
                return;
            }
            $.Notify.show('Undo functionality not yet available for ' + action.ActionName);
        };

        var init = function () {
            $('#undo-button').bind("click", function () {
                if (Undo.data) {
                    $('#s2id_undo-list').hide();
                    Undo.data = undefined;
                    return;
                }
                $.ajax({
                    url: '/Undo/10',
                    type: 'GET',
                    dataType: 'json'
                }).done(function (data) {
                    Undo.data = data;
                    var selectData = _.collect(data, function (e) { return { id: e.Id.toString(), text: actionToString(e) }; });
                    if (!$('#undo-list').data("select2")) {
                        $('#undo-list').select2({
                            data: selectData
                        });
                        $('#undo-list').change(function (e) {
                            var theId = parseInt(e.val);
                            var action = _.find(Undo.data, function (item) {
                                return item.Id == theId;
                            });
                            $('#s2id_undo-list').hide();
                            Undo.data = undefined;
                            undo(action);
                        });
                        $('#undo-list').select2("open");
                    } else {
                        $('#undo-list').select2("data", selectData);
                        $('#s2id_undo-list').show();
                        $('#undo-list').select2("open");
                    }
                });
            });

            $('#undo-button').show();
        };

        Undo.init = init;

        return Undo;
    });
